import { type Voice } from '@aws-sdk/client-polly'
import { Store, useStore } from '@tanstack/react-store'

export const langVoicesStore = new Store<{
  langVoices: Voice[]
  voices: Voice[]
  loading: boolean
  status: 'success' | 'error' | 'idle'
}>({
  langVoices: [],
  loading: false,
  voices: [],
  status: 'idle',
})

const setLangVoices = (langVoices: Voice[]) => {
  langVoicesStore.setState(state => ({
    ...state,
    langVoices,
  }))
}

const setLoading = (loading: boolean) => {
  langVoicesStore.setState(state => ({
    ...state,
    loading,
  }))
}

const setVoices = (voices: Voice[]) => {
  langVoicesStore.setState(state => ({
    ...state,
    voices,
  }))
}

const setStatus = (status: 'success' | 'error' | 'idle') => {
  langVoicesStore.setState(state => ({
    ...state,
    status,
  }))
}

export const useLangVoicesStore = <T>(selector: (state: typeof langVoicesStore.state) => T) => {
  return useStore(langVoicesStore, selector)
}

export const langVoicesStoreActions = {
  setLangVoices,
  setLoading,
  setVoices,
  setStatus,
}
